import React, { useState } from 'react'
import {
    Box,
    Card,
    CardContent,
    Typography,
    IconButton
} from '@material-ui/core'
import { useStyles } from './styles'
import { useSelector } from 'react-redux'
import { PencilIcon, Replace } from 'lucide-react'
import moment from 'moment'
import { REPORT_TYPES } from 'web/src/app/root/hooks/useReportTypes'
import { DeviceConfirmReplaceBaitModal } from '../device-confirm-replace-bait'

export const DeviceBaitCard = ({
    device,
    onEdit,
    onSetCurrentTab,
    overridingLocationSettings,
    canUpdate,
    onConfirmReplaceBait
}) => {
    const classes = useStyles()
    const { theme, locale } = useSelector(state => state.main)
    const [isConfirmReplaceBaitModalOpen, setIsConfirmReplaceBaitModalOpen] =
        useState(false)
    const isReplaceBaitDisabled =
        !canUpdate || Boolean(overridingLocationSettings?.data?.bait_settings)
    const usesLocationBaitSettings =
        Boolean(overridingLocationSettings?.data?.bait_settings) &&
        !device.override_location_settings
    const baitSettings = usesLocationBaitSettings
        ? overridingLocationSettings.data.bait_settings
        : device

    const baitAvailable =
        device.last_report_type !== REPORT_TYPES.bait_low &&
        device.last_report_type !==
            REPORT_TYPES.activity_threshold_reached_and_bait_low
    const baitStatusColor = baitAvailable ? theme.active : theme.error

    return (
        <Box>
            <Typography>{locale.devices.bait}</Typography>

            <Card className={classes.deviceInfoCard}>
                <CardContent className={classes.deviceInfoCardContent}>
                    <Box className={classes.deviceInfoCardHeader}>
                        <div>
                            {usesLocationBaitSettings ? (
                                <div
                                    style={{
                                        marginBottom: 10,
                                        color: theme.textSecondary
                                    }}>
                                    {`ⓘ ${locale.locations.lBasedSettingsAreApplied}`}
                                </div>
                            ) : null}
                            <Box className={classes.baitStatusWrapper}>
                                <Box
                                    className={classes.baitStatusIndicator}
                                    style={{ backgroundColor: baitStatusColor }}
                                />
                                <Typography className={classes.baitStatusText}>
                                    {baitAvailable
                                        ? locale.devices.baitAvailable
                                        : locale.devices.baitLow}
                                </Typography>
                            </Box>
                        </div>
                        {usesLocationBaitSettings ? null : (
                            <IconButton onClick={onEdit}>
                                <PencilIcon
                                    size={20}
                                    color={theme.textPrimary}
                                    onClick={() => onSetCurrentTab('settings')}
                                />
                            </IconButton>
                        )}
                    </Box>

                    <Box
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                        <Box className={classes.baitAmountWrapper}>
                            <Typography className={classes.baitAmountSymbol}>
                                {baitAvailable ? '>' : '<'}
                            </Typography>
                            <Typography className={classes.baitAmountValue}>
                                {baitSettings.bait_calibration_weight_grams}g
                            </Typography>
                        </Box>
                        <IconButton
                            aria-label={locale.devices.replaceBait}
                            onClick={() =>
                                setIsConfirmReplaceBaitModalOpen(true)
                            }
                            disabled={isReplaceBaitDisabled}>
                            <Replace
                                size={20}
                                color={
                                    isReplaceBaitDisabled
                                        ? theme.textSecondary
                                        : theme.textPrimary
                                }
                            />
                        </IconButton>
                    </Box>

                    <Typography className={classes.baitLastReplacement}>
                        {locale.devices.lastReplacement ||
                            locale.devices.lastReplacement}
                        :{' '}
                        {device.last_bait_replaced_at
                            ? moment(device.last_bait_replaced_at).format(
                                  'DD.MM.YYYY HH:mm'
                              )
                            : '--'}{' '}
                        {device.last_bait_replaced_by_name
                            ? `(${device.last_bait_replaced_by_name})`
                            : ''}
                    </Typography>
                </CardContent>
            </Card>
            <DeviceConfirmReplaceBaitModal
                open={isConfirmReplaceBaitModalOpen}
                setOpen={setIsConfirmReplaceBaitModalOpen}
                onConfirmClick={onConfirmReplaceBait}
                deviceId={device.id}
            />
        </Box>
    )
}
